import React, { useMemo } from "react";

import AddCircleOutlinedIcon from "@mui/icons-material/AddCircleOutlined";
import { Stack, Typography } from "@mui/material";
import { DealCreate } from "components/modals";
import { useCanCreateDeal, useNavigate, usePrompt } from "hooks";
import { useAccountSelector } from "store";

interface Props {}

export const AddDealCard: React.FC<Props> = () => {
  const openPrompt = usePrompt();
  const navigate = useNavigate();
  const canCreateDeal = useCanCreateDeal();
  const { freemium_account_settings } = useAccountSelector() || {};
  const createDeal = async () => {
    const data = await openPrompt({ Component: DealCreate, props: {} });

    if (!data) return;

    navigate({ route: "deal", params: { deal_id: data.id } });
  };

  const hintLimitations: string = useMemo(() => {
    if (!freemium_account_settings) return "";
    if (freemium_account_settings?.number_of_deals >= freemium_account_settings?.max_deals)
      return "You have reached the maximum of deals";
    return `${freemium_account_settings?.max_deals - freemium_account_settings?.number_of_deals} more deals available`;
  }, [freemium_account_settings]);

  if (!canCreateDeal) return null;

  return (
    <Stack
      onClick={createDeal}
      sx={{
        bgcolor: "white",
        borderRadius: "8px",
        p: "16px",
        gap: "0px",
        cursor: "pointer",
        minHeight: "74px",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
        maxWidth: "100%",
        minWidth: 0,
        boxShadow: "0px 1px 2px 0px #1212171A",
        boxSizing: "border-box"
      }}
    >
      <Stack
        flexDirection="row"
        sx={{
          alignItems: "center",
          justifyContent: "center",
          gap: "8px"
        }}
      >
        <AddCircleOutlinedIcon sx={{ color: "#071F35", width: "24px", height: "24px" }} />
        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: 500,
            color: "#0a3142",
            lineHeight: 1.2
          }}
        >
          Add deal
        </Typography>
      </Stack>
      <Stack alignItems="center">
        <Typography
          sx={{
            fontSize: "14px",
            color: "#5d7782",
            lineHeight: 1.2,
            whiteSpace: "nowrap"
          }}
        >
          {hintLimitations}
        </Typography>
      </Stack>
    </Stack>
  );
};
